function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .tt0{fill:none;stroke:#0071BC;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "tt0",
  x1: 26.2,
  y1: 3,
  x2: 45.2,
  y2: 3
}), /*#__PURE__*/React.createElement("line", {
  className: "tt0",
  x1: 26.2,
  y1: 9,
  x2: 45.2,
  y2: 9
}), /*#__PURE__*/React.createElement("line", {
  className: "tt0",
  x1: 26.2,
  y1: 15,
  x2: 45.2,
  y2: 15
}), /*#__PURE__*/React.createElement("polyline", {
  className: "tt0",
  points: "3.1,10.8 7.3,15.1 17.2,5.2     "
}));

var SvgListViewActive = function SvgListViewActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "listenable block",
    id: "Layer_17",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "18px",
    viewBox: "0 0 48 18",
    style: {
      enableBackground: "new 0 0 48 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListViewActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_view_active.b099a8a7.svg";
export { ForwardRef as ReactComponent };